import * as React from 'react'

type UseImageUploaderConfig = {
  handleChange: (file: File, url: Promise<string>) => void
}

export type UseImageUploader = {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => File | undefined
  onDrop: (event: React.DragEvent<HTMLElement>) => File | undefined
}

export function useImageUploader({ handleChange }: UseImageUploaderConfig): UseImageUploader {
  return {
    onChange: React.useCallback(onChange, [handleChange]),
    onDrop: React.useCallback(onDrop, [handleChange]),
  }

  function onChange(event: React.ChangeEvent<HTMLInputElement>): File | undefined {
    const files = event.currentTarget.files
    if (files && files.length > 0) {
      const file = files[0]
      handleChange(file, previewUrl(file))
      return file
    }
  }

  function onDrop(event: React.DragEvent<HTMLElement>): File | undefined {
    const files = event.dataTransfer.files
    if (files && files.length > 0) {
      const file = files[0]
      handleChange(file, previewUrl(file))
      return file
    }
  }

  function previewUrl(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()

      reader.addEventListener('load', () => {
        if (typeof reader.result === 'string') {
          resolve(reader.result)
        }
      })
      reader.addEventListener('error', () => {
        if (reader.error !== null) {
          reject(reader.error)
        }
      })
      reader.readAsDataURL(file)
    })
  }
}
